import { API_CALL } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_SEARCH_FACETS } from 'actions/apiActionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import getMerchandiseSearchFacets from 'api/merchandise/getMerchandiseSearchFacets'
import getObjectKey from 'lib/object/getObjectKey'

function fetchMerchandiseSearchFacets(filters?: App.MerchandiseFilters): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getObjectKey(filters ?? {})
    const facets = state.merchandise.merchandiseSearchFacets[key]

    if (facets) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_SEARCH_FACETS,
      request: () => getMerchandiseSearchFacets(filters),
      key,
    },
    )
  }
}

export default fetchMerchandiseSearchFacets
